import api from 'Application/api/api';

const getClientContactPeople = (clientId, cancelToken = null) =>
    api.get(`project-manager/clients/${clientId}/contact-people`, {
        cancelToken,
    });

export default getClientContactPeople;
